// src/pos-app/surfaces/config.js
//
// F12a-N — build-time surface flags for the native POS app.
//
// Each station's main tab can be served either by a NATIVE surface (purpose-
// built components under src/pos-app/surfaces/<station>/) or by the LEGACY
// wrapped web page (e.g. CashierSalesPage hosted inside the station shell
// with navigation-escape interception).
//
// Flipping a station back to 'legacy' must fully restore the wrapper
// behavior — stations read this flag and switch wholesale (see
// stations/CashierStation.js, stations/WaiterStation.js,
// stations/KdsStation.js). The flag is a build-time constant, not runtime
// state: all three stations are native on this branch (F12a-N Task K1
// completed the set with the KDS board).
export const SURFACES = {
    cashier: 'native',
    waiter: 'native',
    kds: 'native',
};

// True when `station` ('cashier' | 'waiter' | 'kds') is served by its
// native surface. Unknown stations are never native.
export function isNativeSurface(station) {
    return SURFACES[station] === 'native';
}

export default SURFACES;
